// Use jquery only for Ajax request
import $ from "jquery"
import AppConfig from "config/config.json"
import translationFR from 'front/translations/messages.fr.json';
import translationEN from 'front/translations/messages.en.json';
import translationDE from 'front/translations/messages.de.json';
import translationES from 'front/translations/messages.es.json';
import translationIT from 'front/translations/messages.it.json';

export var getTranslations = function (locale) {
    let translation;
    switch (locale) {
        case 'en':
            translation = translationEN;
            break;
        case 'de':
            translation = translationDE;
            break;
        case 'es':
            translation = translationES;
            break;
        case 'it':
            translation = translationIT;
            break;
        default:
            translation = translationFR;
    }
    return translation;
}

export var getConfigAsync = function (urlConfig) {
    return new Promise(resolve => {
        $.ajax({
            type: "GET",
            async: true,
            url: urlConfig,
            success: function (result) {
                resolve(result.data);
            }
        });
    });
}

export var getTimelineAsync = function (stationId) {
    return new Promise(resolve => {
        $.ajax({
            type: "GET",
            async: true,
            url: AppConfig.urlMetadata + '/' + stationId + '/metadata-all-cover',
            success: function (result) {
                result.data.forEach(function (item, index) {
                    const splitTitle = item.title.replace('˗', '-').split(' - ');
                    result.data[index].author = splitTitle.shift();
                    result.data[index].title = splitTitle.join(' - ');
                })
                resolve(result.data);
            }
        });
    });
}

export var isAuthorized = function (stream) {
    if (AppConfig.env === "dev") {
        return true;
    }

    // Default not authorized
    var result = false;
    $.ajax({
        type: "POST",
        async: false,
        url: AppConfig.urlAccess,
        data: {
            mountpoint: getMountpointFromStream(stream),
            urlParam: (new URL(stream.url)).search.substring(1).replaceAll('&', ',')
        },
        success: function (response) {
            result = response.data
        }
    });

    return result;
}

export var isDomainAuthorized = function (playerUuid) {
    if (AppConfig.env === 'dev' || document.referrer === '') {
        return true;
    }
    // Default not authorized
    let result = false;
    $.ajax({
        type: "POST",
        async: false,
        url: AppConfig.urlAccessDomain.replace('{player_uuid}', playerUuid),
        data: {domain: document.referrer},
        success: function (response) {
            result = response.result
        }
    });
    return result;
}


export var formatConfig = function (config, state) {

    const locale = state.locale ? state.locale : config.language;
    const autoplay = state.autoplay ? state.autoplay : config.is_auto_start;

    // Change the volume if the default volume change
    let volume = state.volume !== undefined ? state.volume : config.volume / 100;
    if (state.neverPlayed && state.volume !== config.volume) {
        volume = config.volume / 100;
    }
    let title = config.title ? config.title : config.display_name;

    let translations = state.translations;
    if (!translations) {
        translations = state.locale ? getTranslations(state.locale) : getTranslations(config.language);
    }

    let result = {
        playername: config.display_name,
        url: config.url ? config.url : state.url,
        title: title,
        author: config.artist,
        displayListener: config.is_listeners,
        numberListener: config.listeners,
        listenerHold: config.listeners_hold,
        autoplay: autoplay,
        volume: volume,
        defaultVolume: config.volume / 100,
        logo: config.is_logo_enable,
        locale: locale,
        spectrum: config.is_spectrum,
        cover: config.is_cover,
        thumbnail: config.thumbnail,
        is_station_thumbnail: config.is_station_thumbnail ?? false,
        is_metadata_display: config.is_metadata_display ?? false,
        translations: translations,
        embedEnable: config.is_embed,
        facebook: config.facebook_link,
        twitter: config.twitter_backlink,
        twitterHashtags: config.twitter_hashtag ? config.twitter_hashtag.split(',') : null,
        twitterAccount: config.twitter_account,
        backgroundColor: "#" + config.background_color,
        buttonColor: "#" + config.button_color,
        secondaryColor: "#" + config.secondary_color,
        loadingUrl: switchTranslationFile(config.loading, locale),
        unavailableUrl: switchTranslationFile(config.unavailable, locale),
        unauthorizedUrl: switchTranslationFile(config.restriction, locale),
        stations: config.stations,
        isHlsBuffered: config.is_hls_buffered ?? false,
        isDirectControl: config.is_direct_control ?? false
    }

    // Avoid undefined date in preview
    if (config.date) {
        result.date = config.date;
    }

    if (state.neverPlayed) {
        result.display = config.thumbnail ? config.thumbnail : AppConfig.storage + 'defaultImage.svg';
    }
    result.timeline = getTimelineFromConfig(config, state)

    if (!config.stations || config.stations.length === 0) {
        let defaultConfig = defineSpecificUrl('temp.mp3');
        config.stations = defaultConfig.stations;
    }

    config.stations.forEach(function (station, index) {
        if (!station.streams || station.streams.length === 0) {
            config.stations[index].streams = [{
                "is_main": true,
                "type": 'ice',
                "uuid": -1,
                "url": 'temp.mp3',
                "name": config.title,
                "format": 'mp3',
                "bitrate": -1
            }];
        }
    })


    Object.assign(result, getStreamFromConfig(config, state));

    return result;
}

/**
 * Return a base url without any query param
 * @param url
 * @returns {string}
 */
export const getBaseUrl = (url) => {
    try {
        const baseUrl = new URL(url);
        return baseUrl.origin + baseUrl.pathname;
    } catch (e) {
        return url;
    }
}

export var defineSpecificUrl = function (url, config = {}) {
    const baseUrl = getBaseUrl(url);
    let mountpoint = baseUrl.split('/').pop().split('?').shift();
    let name = mountpoint;
    let extension = mountpoint.split('.').pop();
    if (extension === 'm3u8' && mountpoint === "manifest") {
        name = baseUrl.split('/')[baseUrl.split('/').length - 2];
    }
    config.title = name;
    config.display_name = name;
    config.artist = '';
    config.is_cover = false;
    config.is_spectrum = false;
    config.stations = [{
        "id": 1,
        "order": 1,
        "thumbnail": null,
        "streams": [{
            "is_main": true,
            "type": extension === 'm3u8' ? 'hls' : 'ice',
            "uuid": -1,
            "url": url,
            "name": name,
            "format": extension === 'm3u8' ? 'hls' : extension,
            "bitrate": -1
        }]
    }];
    return config;
}

export var getStreamFromConfig = (config, state) => {
    let result = {streams: [], stream: null};
    // Sometime tokens is undefined for no reason
    let tokens = state.tokens ?? '';
    // Max 3 streams available
    for (let i = 0; i < 3 && i < config.stations[state.stationIndex].streams.length; i++) {
        let stream = config.stations[state.stationIndex].streams[i];
        let separatorAndTokens = '';
        if (tokens[stream.name]) {
            separatorAndTokens = (stream.url.includes('?') ? '&' : '?') + 'token=' + tokens[stream.name];
        }
        let newStream = {
            uuid: stream.uuid,
            url: stream.url + separatorAndTokens,
            name: stream.name
        };

        if (stream.type === 'hls') {
            newStream.format = stream.type;
            result.fragment = stream.fragment_size;
            result.playlist = stream.playlist_size;
            if (stream.bitrates) {
                result.bitrates = stream.bitrates.split(',');
            }
        } else {
            newStream.bitrate = stream.bitrate;
            newStream.format = stream.format;
        }

        // Define main stream
        if (stream.is_main) {
            result.main = newStream;
        }
        result.streams.push(newStream);
    }
    if (!result.main) {
        result.main = result.streams[0];
    }
    result.stream = result.main;
    return result;
}

export var isTemplateConfig = (configUrl): boolean => {
    return !!configUrl.match(/\/config-.*\.json$/);
}

function getTimelineFromConfig(config, state) {
    // Default return if timeline is empty
    if (!config.timeline || config.timeline.length === 0) {
        let cover = config.thumbnail ? config.thumbnail : AppConfig.storage + 'defaultImage.svg'
        return [{date: 1, title: config.display_name, author: "", cover: cover}]
    }
    config.timeline.forEach(function (itemConfig, index) {
        if (!config.is_cover || !config.timeline[index].cover) {
            if (config.thumbnail) {
                config.timeline[index].cover = config.thumbnail;
            } else {
                config.timeline[index].cover = AppConfig.storage + 'defaultImage.svg';
            }
        }

        config.timeline[index].author = config.timeline[index].artist;
        if (config.timeline[index].title === "" || config.timeline[index].title === false) {
            config.timeline[index].title = config.playername;
        }
    });

    config.timeline.concat(state.timeline);
    config.timeline.sort(function (a, b) {
        return b.date < a.date;
    });

    return config.timeline;
}

function switchTranslationFile(file, locale) {
    const split = file.split('.');
    let newFile = file;
    if (split[split.length - 2].length === 2 && $.inArray(split[split.length - 2], ['fr', 'en', 'de', 'it', 'es']) !== -1) {
        split[split.length - 2] = locale;
        newFile = split.join('.');
    }
    return newFile;
}

function getMountpointFromStream(stream) {
    if (stream.format === 'hls') {
        return stream.url.split('/')[stream.url.split('/').length - 2] + ".hls";
    } else {
        return stream.url.split('?').shift().split('/').pop();
    }
}
